import { useState } from "react";
import type { LabReportFile } from "@ferrivia/api-contract";
import { useApi, useTracker } from "@ferrivia/auth-web";
import { useFormatters, useTranslation } from "@ferrivia/i18n";
import { openPdf } from "@ferrivia/lab-ui";
import { Text } from "@ferrivia/ui";
import { ChevronRight, FileText } from "lucide-react";
import { formatCollectedOn } from "./trend";
import s from "./ResultsScreen.module.css";

export function LabReportList({ files }: { files: LabReportFile[] }) {
  const api = useApi();
  const tracker = useTracker();
  const { t } = useTranslation("client");
  const { tag } = useFormatters();
  const [failed, setFailed] = useState(false);

  if (files.length === 0) return null;

  async function open(id: string) {
    setFailed(false);
    tracker.track("results.report_opened", {});
    try {
      await openPdf(() => api.labs.reportFileContent(id));
    } catch {
      setFailed(true);
    }
  }

  return (
    <section className={s.reports} aria-label={t("results.reports.title", "Omat laboratorioraportit")}>
      <Text as="h2" size="md" weight="bold">
        {t("results.reports.title", "Omat laboratorioraportit")}
      </Text>
      <ul className={s.reportList}>
        {files.map((file) => (
          <li key={file.id}>
            <button type="button" className={s.reportItem} onClick={() => void open(file.id)}>
              <FileText aria-hidden size={20} className={s.reportIcon} />
              <span className={s.reportLabel}>
                {t("results.reports.item", "Raportti {{date}}", { date: formatCollectedOn(file.collectedOn, tag) })}
              </span>
              <ChevronRight aria-hidden size={20} className={s.reportChevron} />
            </button>
          </li>
        ))}
      </ul>
      {failed && (
        <Text as="p" size="sm" className={s.reportError}>
          {t("results.reports.openFailed", "Raportin avaaminen epäonnistui. Yritä uudestaan.")}
        </Text>
      )}
    </section>
  );
}
